import type { Transcript } from '../../../Transcript';
import type { TextAlignment } from '../../../../enums';
import type { CanvasTextStyleRenderer } from '../../TextAsset/renderer/CanvasTextStyleRenderer';
import { CanvasLayoutWordMetrics } from '../../TextAsset/metrics/CanvasLayoutWordMetrics';
import { generateWordMetricsWhichFitWithinMaxWidth } from '../../TextAsset/metrics/CanvasTextMetrics';

/**
 * The minimum duration in milliseconds to be considered a pause.
 */
const MIN_PAUSE_DURATION = 2000;

export const buildMetricsForCaptions = ({
    transcript,
    alignment,
    style,
    maxWidth,
    maxHeight,
}: {
    transcript: Transcript;
    alignment: TextAlignment;
    style: CanvasTextStyleRenderer;
    maxWidth: number;
    maxHeight: number;
}) => {
    let wordIndexOffset = 0;
    return transcript.getTimeRangesWithoutPauses(MIN_PAUSE_DURATION).flatMap((timeRange) => {
        const tempTranscript = transcript.getTrimmedTranscript([
            [timeRange.startTime, timeRange.endTime],
        ]);
        const { wordsWithSpaces, sourceWordReferenceIndices } =
            tempTranscript.generateWordsFromTranscript(wordIndexOffset);

        // get the last word index (-1 are spaces)
        wordIndexOffset = sourceWordReferenceIndices.filter((num) => num !== -1).pop();
        wordIndexOffset += 1;

        const wordMetricsList = generateWordMetricsWhichFitWithinMaxWidth({
            words: wordsWithSpaces,
            highlightAreas: [],
            sourceWordReferenceIndices,
            normalStyle: style,
            highlightStyle: style,
            maxWidth,
            wordBreak: true,
        });

        return CanvasLayoutWordMetrics.layout({
            wordMetricsList,
            alignment: alignment,
            style,
            wordBreak: true,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            maxLineCount: 1,
            minOccupiedAreaPercentage: 30,
            moveWordsAfterLastPunctuationToNextChunk: true,
            removeTrailingPunctuationOnLastLineFromLastChunk: false,
        });
    });
};
